import React from 'react';
import { Modal, Button, Alert, Row, Col, Badge } from 'react-bootstrap';

const AppUpdateModal = ({
    show = false,
    onHide = () => { },
    currentVersion = null,
    serverVersion = null,
    onUpdateNow = () => { },
    onLater = () => { }
}) => {
    const handleUpdateNow = () => {
        onUpdateNow();
    };

    const handleLater = () => {
        onHide();
        onLater();
    };

    return (
        <Modal
            show={show}
            onHide={handleLater}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    <i className="bi bi-arrow-repeat me-2"></i>
                    App Update Available
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Alert variant="info" className="mb-3">
                    <i className="bi bi-info-circle me-2"></i>
                    A new version of the Enterprise Portal is available. Please update to get the latest features and security improvements.
                </Alert>

                {currentVersion && serverVersion && (
                    <Row className="mb-3">
                        <Col md={6}>
                            <div className="text-center p-3 border rounded">
                                <h6 className="text-muted mb-2">Current Version</h6>
                                <div>
                                    <Badge bg="secondary" className="me-2">
                                        v{currentVersion.version}
                                    </Badge>
                                    <Badge bg="secondary">
                                        #{currentVersion.buildNumber}
                                    </Badge>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="text-center p-3 border rounded">
                                <h6 className="text-muted mb-2">Available Version</h6>
                                <div>
                                    <Badge bg="success" className="me-2">
                                        v{serverVersion.version}
                                    </Badge>
                                    <Badge bg="success">
                                        #{serverVersion.buildNumber}
                                    </Badge>
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}

                <div className="text-muted small">
                    <p className="mb-1">
                        <strong>What happens when you update:</strong>
                    </p>
                    <ul className="mb-0 ps-3">
                        <li>The application will refresh automatically</li>
                        <li>You will remain logged in</li>
                        <li>Any unsaved changes may be lost</li>
                        <li>The update usually takes just a few seconds</li>
                    </ul>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="outline-secondary"
                    onClick={handleLater}
                    size="sm"
                >
                    <i className="bi bi-clock me-1"></i>
                    Later
                </Button>
                <Button
                    variant="primary"
                    onClick={handleUpdateNow}
                    size="sm"
                >
                    <i className="bi bi-arrow-repeat me-1"></i>
                    Update Now
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AppUpdateModal;